var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Houses({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.777,
    height: 17.66,
    viewBox: "0 0 26.777 17.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1168",
    "data-name": "Groupe 1168",
    transform: "translate(-202.223 -254.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1009",
    "data-name": "Groupe 1009",
    transform: "translate(220.954 264.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_491",
    "data-name": "Trac\\xE9 491",
    d: "M164.123,57.909l1.54-1.384v-1.96h.886v1.19l1.58-1.423,4.04,3.577v3.819h-2.927v-1.19a1.148,1.148,0,0,0-1.113-1.153h0a1.143,1.143,0,0,0-1.08,1.153v1.19h-2.926Zm2.193,2.322h-.767v.8h.767Zm-.923-.963h-.77v.847h.77Zm.923,0h-.767v.847h.767Zm-.923.963h-.77v.8h.77Z",
    transform: "translate(-164.123 -54.332)",
    fill: "#d0d0d0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1038",
    "data-name": "Groupe 1038",
    transform: "translate(-77.361 194.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_22",
    "data-name": "Union 22",
    d: "M16349.067-12600.2v-2.35a2.336,2.336,0,0,0-2.288-2.343,2.332,2.332,0,0,0-2.29,2.343v2.35h-6.129v-11.642h16.836v11.642Zm3.394-1.492h1.629v-1.639h-1.629Zm-1.919,0h1.625v-1.639h-1.625Zm-9.223,0h1.623v-1.639h-1.623Zm-1.93,0h1.623v-1.639h-1.623Zm13.071-1.924h1.629a1.724,1.724,0,0,0-1.629-1.633Zm-1.919,0h1.625v-1.633A1.784,1.784,0,0,0,16350.542-12603.613Zm-9.223,0h1.623a1.724,1.724,0,0,0-1.623-1.633Zm-1.93,0h1.623v-1.633A1.724,1.724,0,0,0,16339.39-12603.613Zm13.071-3.178h1.629v-1.639h-1.629Zm-1.919,0h1.625v-1.639h-1.625Zm-9.223,0h1.623v-1.639h-1.623Zm-1.93,0h1.623v-1.639h-1.623Zm13.071-1.924h1.629a1.729,1.729,0,0,0-1.629-1.635Zm-1.919,0h1.625v-1.635A1.789,1.789,0,0,0,16350.542-12608.715Zm-9.223,0h1.623a1.729,1.729,0,0,0-1.623-1.635Zm-1.93,0h1.623v-1.635A1.729,1.729,0,0,0,16339.39-12608.715Zm-1.029-3.549c10.335-6.125,6.5-6.125,16.836,0Z",
    transform: "translate(-16056.953 12678.231)",
    fill: "#a9aaad",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Houses);
export default __webpack_public_path__ + "static/media/2houses.03f6664b01f87cf82f22cf7aff1b1d48.svg";
export { ForwardRef as ReactComponent };